export default __webpack_public_path__ + "static/media/bluetech.a03f901c.jpg";